jQuery(document).ready(function($){
    
    // Toggle dropdown on icon click
    $('.drop-down-icon').on('click', function (e) {
        e.stopPropagation(); // Prevent document click from firing
        var menu = $('#' + $(this).data('id'));

        if (menu.hasClass('toggle')) {
            menu.removeClass('toggle'); // Toggle off
            $(this).removeClass("active")
        } else {
            $('.drop-down-menu').removeClass('toggle'); // Close others
            menu.addClass('toggle');
            $(this).addClass('active') // Open clicked menu
        }
    });

    // Prevent clicking inside the menu from closing it
    $('.drop-down-menu').on('click', function (e) {
        e.stopPropagation();
    });

    // Close dropdown if clicking outside icons or menus
    $(document).on('click', function () {
        $('.drop-down-menu').removeClass('toggle');
        $('.drop-down-icon').removeClass('active');
    });


    $('.csr-panel').on('click', function (e) {
        const $panel = $(this);
        const $content = $panel.find('.csr-panel__content');
        const $icon = $panel.find('.csr-panel__icon');

        // Prevent re-triggering when clicking inside the content
        if ($(e.target).closest('.csr-panel__content').length) return;

        if ($content.hasClass('is-active')) {
            $content.removeClass('is-active').slideUp(300);
            $icon.removeClass('active');
        } else {
            // Open this one
            $content.addClass('is-active').slideDown(300);
            $icon.addClass('active');
        }
    });

    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    $(window).on("scroll", function() {
        $(".slider-section-container").each(function () {
            let elementTop = $(this).offset().top;
            let elementHeight = $(this).outerHeight();
            let elementMid = elementTop + elementHeight / 2;
            let windowTop = $(window).scrollTop();
            let isMobileDevice = isMobile() || $(window).width() < 1200;
            let offset = isMobileDevice ? 0 : 100;
            let windowBottom = windowTop + $(window).height() - offset;
            let triggerPoint = isMobileDevice ? elementTop - 100 : elementMid;

            if (triggerPoint < windowBottom) {
                const $container = $(this);
                const $dates = $container.find('.date');
                let dateIndex = 0;


                let showTimeline = setInterval(() => {
                    if (dateIndex < $dates.length) {
                        // Show next date with fade-in effect
                        $($dates[dateIndex]).removeClass('dont-show').addClass('show');

                        if ( dateIndex > 0 ) {
                            $($dates[dateIndex - 1]).addClass('show-line');
                        }
                        dateIndex++;
                    } else {
                        clearInterval(showTimeline)
                    }
                }, 200);
                    
            }
        });
    });
});